var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"width":1000,"height":200,"chart-data":_vm.chartData,"options":_vm.chartOptions,"styles":_vm.chartStyles}})}
var staticRenderFns = []

export { render, staticRenderFns }